import { Injectable } from '@angular/core';
import { Device } from '../models/data/device';
import { ApiService, QueryParam } from './api.services';

// Provides an easier way to cache and retrieve device information
@Injectable({
	providedIn: 'root',
})
export class DeviceDetailsService {
	private device?: Device;

	constructor(private readonly apiService: ApiService) {}

	public async saveDeviceDetails(device: Device) {
		// if we have new device information passed in always update it so we don't have old information cached
		this.saveDevice(device);
	}

	public async getDevice(deviceId: string) {
		if (!this.device || this.device.id !== deviceId) {
			this.device = await this.apiService.getDeviceById(deviceId);
		}
		return this.device;
	}

	public async getDeviceWithCodeGenerationDetails(deviceId: string) {
		return await this.apiService.getDeviceById(deviceId);
	}

	public saveDevice(device: Device) {
		this.device = device;
	}
}
